import React, {useCallback, useEffect, useState} from 'react';
import axios from "axios";
import ENV from "../ENV.json";
import {useHistory} from "react-router-dom";
import {Box, TableContainer} from "@chakra-ui/react";
import MaterialTable from "material-table";
import './TrashPointOfInterest.css'
import RequestingPopup from "./RequestingPopup";
import Popup from "./Popup";
import Loading from "./Loading";
import {reactLocalStorage} from "reactjs-localstorage";


let leave_key;
let id_to_handle = null;
const TrashPointOfInterest = (props) => {

    const history = useHistory();
    const [allPoiName, setAllPoiName] = useState([]);
    const [allPoiNameDownloading, setAllPoiNameDownloading] = useState(false);

    //POPUPS
    const [modalOpen, setModalOpen] = useState(false);
    const [popupData, setPopupData] = useState({});

    //Loading dei punti d'interesse da cancellare definitivamente o ripristinare
    const [isLoading, setIsLoading] = useState(false);


    //Questa funzione ripristina un punto d'interesse cancellato se fornito un ID valido
    const restorePOI = useCallback(() => {
        setIsLoading(true);
        axios.post(`${ENV[ENV.ENV_STATE].baseUrl}/restore/poi`, {"ID": id_to_handle})
            .then(function (response) {
                if (response?.data?.status) {
                    console.log("Sembra che tutto sia andato correttamente")
                } else {
                    console.log("Sembra che non sia andata al 100% bene ma nemmeno male")
                    console.log(response?.data);
                }
                setPopupData(response?.data);
                setModalOpen(true);
            })
            .catch(function (error) {
                setPopupData({
                    status: false,
                    title: "Errore imprevisto",
                    message: "Non è stato possibile proseguire con la richiesta!"
                })
                setModalOpen(true);
                if (error.response.status === 403) {
                    history.push('/')
                }
            })
            .then(function (response) {
                setIsLoading(false);
                getAllDeletedPoi();
            });

    }, []);

    //Questa funziona cancella definitivamente un punto d'interesse presente all'interno della base dati.
    //Richiede come parametro per cancellare un ID valido.
    const deleteForever = useCallback(() => {
        console.log("Stiamo per cancellare definitamente l'ID " + id_to_handle);


    }, []);

    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [popupTitle, setPopupTitle] = useState('Titolo');
    const [popupMsg, setPopupMsg] = useState('MSG');
    const [popupDenyLabel, setPopupDenyLabel] = useState('Rifiuta');
    const [popupAcceptLabel, setPopupAcceptLabel] = useState('Accetta');

    const leave = {
        "restore": {func: restorePOI},
        "delete_forever": {func: deleteForever},
    };

    const getAllDeletedPoi = useCallback(() => {
        setAllPoiNameDownloading(true);
        axios.get(`${ENV[ENV.ENV_STATE].baseUrl}/get/all/deleted/poi`, {withCredentials: true, credentials: 'include'})
            .then(function (response) {
                if (response?.data?.status) {
                    setAllPoiName(response?.data?.rows)
                } else {
                    setPopupData(response?.data);
                    setModalOpen(true);
                }
            })
            .catch(function (error) {
                setPopupData({
                    status: false,
                    title: "Errore imprevisto",
                    message: "Non è stato possibile caricare i punti di interesse cancellati"
                })
                setModalOpen(true);
                if (error.response.status === 403) {
                    history.push('/')
                }
            })
            .then(function (response) {
                setAllPoiNameDownloading(false)
            });
    }, []);

    //Fetch all POI
    useEffect(() => {
        const User = reactLocalStorage.getObject('User');
        console.log("Abbiamo trovato un User -> "+User);
        if(!User) history.push('/');

        getAllDeletedPoi();
    }, []);

    return (
        <Box {...props?.pageProps}>
            <div>
                <p>Qui puoi trovare tutti i punti di interesse che sono stati cancellati</p>
                <p>In questa sezione puoi solo ripristinare la loro esistenza</p>
                <TableContainer>
                    <MaterialTable
                        isLoading={allPoiNameDownloading}
                        actions={[
                            {
                                icon: 'delete',
                                tooltip: 'Elimina definitivamente dal sistema',
                                onClick: (event, rowData) => {
                                    const id = rowData?.ID;
                                    const title = rowData?.title;
                                    leave_key = "delete_forever";
                                    id_to_handle = id;
                                    setPopupTitle(`Desideri eliminare il punto di interesse ID:${id}`);
                                    setPopupMsg(`Attenzione, ${title}, verra cancellato in maniera definitiva.\nNon sarà possibile più accedere a questo punto se viene confermata l'eliminazione`)
                                    setIsPopupOpen(true)
                                    setPopupDenyLabel('No, ho cambiato idea');
                                    setPopupAcceptLabel('Si, cancellalo per sempre');
                                }
                            },
                            {
                                icon: 'auto_fix_high',
                                tooltip: 'Ripristina il punto eliminato',
                                onClick: (event, rowData) => {
                                    const id = rowData?.ID;
                                    const title = rowData?.title;
                                    id_to_handle = id;
                                    leave_key = "restore";
                                    setPopupTitle(`Desideri ripristinare il punto di interesse ID:${id}`);
                                    setPopupMsg(`Attenzione, ${title}, sarà ripristinato in piattaforma.`)
                                    setIsPopupOpen(true)
                                    setPopupDenyLabel('No, ho cambiato idea');
                                    setPopupAcceptLabel('Si, ripristinalo');
                                }
                            }
                        ]}
                        columns={[
                            {title: 'ID', field: 'ID'},
                            {title: 'Titolo', field: 'title'},
                            {title: 'Indirizzo', field: 'address'},
                        ]}
                        data={allPoiName}
                        title="Cestino"
                    />
                </TableContainer>
                <RequestingPopup
                    title={popupTitle}
                    msg={popupMsg}
                    denyLabel={popupDenyLabel}
                    acceptLabel={popupAcceptLabel}
                    isOpen={isPopupOpen}
                    onDeny={() => {
                        console.log("Hai deciso di non fare nulla, ok!")
                        setIsPopupOpen(false);
                    }}
                    onAccept={() => {
                        console.log("Hai deciso di agire, Caspita!")
                        leave[`${leave_key}`]?.func();
                        setIsPopupOpen(false);
                    }}
                />
                <Popup isOpen={modalOpen} onClose={() => setModalOpen(false)} popupData={popupData}/>
                <Loading isLoading={isLoading}/>
            </div>
        </Box>
    );
}

export default TrashPointOfInterest;
